import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  container: { width: 700, overflow: 'hidden', padding: 25 },
  container2: { padding: '40px  0px 40px 0px' },
}));
